import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container } from 'components/ui'
import s from './politica-de-privacidade.module.css'

export default function PoliticaDePrivacidade() {
  const crums = [
    {
      label: 'Institucional',
    },
  ]
  return (
    <Layout>
      <Head>
        <title>Política de Privacidade e Confidencialidade</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <Container>
        <h1 className={s.title}>Política de Privacidade e Confidencialidade</h1>
        <div className={s.root}>
          <p>
            <strong>Última atualização: 09 de novembro de 2016.</strong>
          </p>
          <p>
            Este termo de uso apresenta as condições da Política de Privacidade e Confidencialidade da Informação na
            utilização dos serviços do site <a href="https://www.fazendinha.me">www.fazendinha.me</a>, do qual
            CLAUDIAWEB CONSULTORIA DE INFORMAÇÕES EIRELI - ME, CNPJ/MF 22.816.619/0001-01, com sede na na Rua Antonio
            Simão da Costa nº 219, Industrial 4 Seção, Ibirité/MG, CEP 32.400-001, é titular.
          </p>
          <p>
            O site www.fazendinha.me (“SITE”), pela natureza dos serviços prestados recolhe e, em alguns casos, revela
            informações sobre os usuários e visitantes de seu site. Esta Política de Privacidade e Confidencialidade
            (“Política”) descreve a informação que o SITE coleta sobre seus usuários e visitantes e as regras a serem
            adotadas, a fim de garantir aos mesmos total transparência no tratamento das informações disponibilizadas.
            <br />
            Com esta Política, o SITE quer demonstrar que a privacidade da informação dos usuários/visitantes é muito
            importante e, por isso, toma precauções e cautelas para resguardar toda a informação, utilizando os
            mecanismos de segurança em informática mais completos, modernos e eficazes.
          </p>
          <p>
            Este documento é parte integrante do Termo e Condições Gerais de Uso (“TERMO”) do SITE, a aceitação do TERMO
            no momento do cadastro o usuário implica na automática aceitação desta Política.
          </p>
          <p>
            I – Ao cadastrar-se e/ou navegar pelo SITE, o usuário e/ou o visitante consente tacitamente na utilização de
            sua informação pessoal, de acordo com as regras a seguir:
          </p>
          <h2>Da Informação exigida</h2>
          <p>
            A primeira providência para desfrutar dos serviços do SITE é registrar-se e informar seus dados pessoais
            (“DADOS PESSOAIS”) completos e exatos. Poderão ser solicitados, recebidos e armazenados os seguintes dados:
            nome de utilizador para operar no SITE, nome, número de documento ou identificação válida e informação de
            contato (como número de telefone fixo, endereço de e-mail, residência ou domicílio, etc.). O SITE poderá
            confirmar os dados pessoais informados e está desde já autorizado a consultar entidades públicas, companhias
            especializadas ou bancos de dados. A informação que o SITE obtiver será tratada de forma confidencial.
          </p>
          <p>
            A qualquer momento o usuário (“USUÁRIO”) registrado no SITE poderá solicitar a extinção ou remoção de seu
            registro, bem como a eliminação de seus dados da base de dados do SITE. Para mais informações, leia
            “Direitos de acesso, remoção e retificação da informação pessoal” abaixo.
          </p>
          <p>
            O SITE coleta e armazena automaticamente informações sobre a atividade dos usuários e visitantes de seu
            site. Tal informação pode incluir a URL de onde eles provêm (seja ela do próprio SITE ou não), a que URL
            acederam em seguida (seja ela do próprio SITE ou não), o navegador que utilizam no momento do acesso, seus
            IPs de acesso, as páginas visitadas, as buscas realizadas, os anúncios, compras ou vendas, qualificações e
            réplicas inseridas, mensagens nos fóruns, dentre outras informações poderão ser armazenadas e retidas.
          </p>
          <p>
            O SITE poderá coletar e armazenar os DADOS PESSOAIS, incluir endereços de e-mails, caso os utilizadores (ou
            terceiros) enviem correspondências (sejam e-mails ou cartas) sobre as atividades ou sobre as mensagens de
            outros usuários/visitantes do SITE.
          </p>
          <h3>Do uso da informação pelo SITE</h3>
          <p>
            Para fornecer um serviço de qualidade e para que seus USUÁRIOS possam realizar operações de forma ágil e
            segura, o SITE requer informações de caráter pessoal, incluindo endereço de e-mail. A coleta dessas
            informações nos permite oferecer aos usuários serviços e funcionalidades que possam ser melhor adequados às
            suas necessidades e personalizar nossos serviços.
          </p>
          <p>A Informação Pessoal que solicitamos tem as seguintes finalidades:</p>
          <ul>
            <li>
              Ajudar o USUÁRIO comprador e o USUÁRIO vendedor a entrar em contato direto na oportunidade que corresponda
              à modalidade de compra. Neste caso, o SITE fornecerá aos interessados seus DADOS PESSOAIS (nome,
              telefones, localidade e correio eletrônico), através de endereços de e-mail ou físico. A informação assim
              conhecida pelo USUÁRIO comprador ou USUÁRIO vendedor, só poderá ser utilizada para efeitos de concluir a
              operação originada no SITE e não deverá ser empregada por nenhum deles com fins publicitários,
              promocionais ou qualquer outro fim não relacionado com a negociação feita pelo SITE, salvo prévia e
              expressa autorização do USUÁRIO.
            </li>
            <li>
              Desenvolver estudos internos sobre os interesses, comportamentos e demografia dos USUÁRIOS para
              compreender melhor suas necessidades e interesses e oferecer melhores serviços ou prover-lhes informação
              relacionada.
            </li>
            <li>
              Melhorar nossas iniciativas comerciais e promocionais e analisar as páginas visitadas, buscas realizadas
              pelos USUÁRIOS, para melhorar nossa oferta de conteúdos e produtos, personalizar conteúdos, sua
              apresentação e serviços. Enviar informação ou mensagens por e-mail sobre novos serviços, mostrar
              publicidades ou promoções, banners, de interesse para nossos usuários, notícias sobre o SITE, além da
              informação expressamente autorizada na seção de preferências. O USUÁRIO poderá solicitar que o excluam das
              listas para o envio de informação promocional ou publicitária.
            </li>
            <li>
              Compartilhar os DADOS PESSOAIS (incluindo endereço de e-mail) com os provedores de serviços ou as empresas
              de “outsourcing” que contribuam para melhorar ou facilitar as operações através do SITE, tais como, mas
              não se limitando a: serviços de transporte, meios de pagamento, seguros ou intermediários na gestão de
              pagamentos, call centers ou programas de fidelidade, entre outros. O SITE zelará para que se cumpram
              certos padrões, mediante a assinatura de acordos ou convênios cujo objeto seja a privacidade dos DADOS
              PESSOAIS dos USUÁRIOS. Não obstante o aqui exposto, o SITE não será responsável pelo uso indevido dos
              DADOS PESSOAIS do USUÁRIO feitas por terceiros. Em alguns casos, estes provedores de serviços recolherão
              informação diretamente do USUÁRIO (por exemplo, se lhes solicitamos que realizem enquetes ou estudos). Em
              tais casos, o USUÁRIO receberá uma notificação a respeito da participação de um provedor de serviços em
              tais atividades, ficando a critério do USUÁRIO as informações que desejar disponibilizar e os usos
              adicionais que os provedores decidam fazer. Para fins de facilitação, por própria iniciativa de informação
              adicional a ditos prestadores de serviços diretamente, estes usarão a informação conforme a suas próprias
              políticas de privacidade. Se for decidido revelar ou compartilhar os DADOS PESSOAIS com terceiros que não
              são provedores de serviços ou empresas filiadas ou relacionadas com o SITE, será requerido o devido
              consentimento.
            </li>
            <li>
              Fornecer os DADOS PESSOAIS dos USUÁRIOS às entidades que intervenham na resolução de disputas entre os
              mesmos, tais como: Seguradoras, Tribunais de Arbitragem ou tribunais competentes para solucionar tais
              disputas.
            </li>
          </ul>
          <h3>Da Confidencialidade da informação</h3>
          <p>
            Uma vez registrado em seu web site, o SITE não venderá, alugará ou compartilhará os DADOS PESSOAIS, exceto
            nas formas aqui estabelecidas.
          </p>
          <ul>
            <li>
              O SITE se compromete a fazer tudo o que estiver ao alcance no sentido de proteger a privacidade da
              informação.
            </li>
            <li>
              Em virtude de ordens judiciais, ou de disposições legais, o SITE pode ser compelido a revelar informação
              às autoridades ou terceiras partes, ou em casos de terceiros possam interceptar a informação ou transmitir
              dados, nestes casos o SITE não responderá pela informação que seja revelada.
            </li>
          </ul>
          <h3>Do Apelido de usuário</h3>
          <p>
            Para interagir dentro do SITE, os usuários devem utilizar um apelido que os identifique. Os USUÁRIOS não
            terão acesso aos DADOS PESSOAIS de outros usuários, salvo quando tenham realizado com ele alguma negociação
            através do SITE, caso em que ambas as partes receberão os dados uma da outra com a finalidade de efetivação
            da transação.
          </p>
          <h3>Da Senha pessoal</h3>
          <p>
            Para acesso aos serviços reservados unicamente aos USUÁRIOS devidamente registrados, estes irão dispor de
            uma senha pessoal. Com esta senha poderão comprar, vender, ofertar, qualificar, dentre outras atividades.
            Esta senha, que é escolhida pelo próprio USUÁRIO e deve ser mantida sob absoluta confidencialidade e, em
            nenhum caso, deverá ser revelada ou compartilhada com outras pessoas.
          </p>
          <p>
            O USUÁRIO será responsável por todos os atos que sejam realizados com o uso de seu nome de usuário e senha
            pessoal, o que incluem pagamentos de tarifas por serviços ou responsabilização por eventuais prejuízos que
            possam vir a sofrer. Se por qualquer razão um USUÁRIO desconfiar que alguém pode conhecer sua senha pessoal,
            deverá modificá-la acessando seu perfil no SITE.
          </p>
          <h3>Do Uso da informação por outros USUÁRIOS</h3>
          <p>
            Para facilitar a interação entre todos os membros da comunidade do SITE, é permitido um acesso limitado a
            certos dados de contato dos demais USUÁRIOS, tais como nome de usuário, telefones, município e endereço de
            e-mail.
          </p>
          <p>Os USUÁRIOS só poderão utilizar os DADOS PESSOAIS de outros USUÁRIOS para:</p>
          <ul>
            <li>Comunicações relacionadas ao SITE que não constituam comunicações comerciais não solicitadas;</li>
            <li>
              Utilizar serviços oferecidos no SITE (por exemplo: depósito, seguros, envio ou transporte e reclamações
              sobre fraude);
            </li>
            <li>
              Qualquer outra finalidade que o USUÁRIO correspondente consinta expressamente, uma vez que tenha sido
              comunicada previamente a informação legalmente requerida.
            </li>
          </ul>
          <p>
            Sob nenhuma circunstância, se deve comunicar os DADOS PESSOAIS ou endereço de e-mail de outro usuário a
            nenhum terceiro sem o consentimento do SITE e do USUÁRIO afetado.
          </p>
          <p>
            Não se recomenda adicionar à agenda de endereços (residencial ou eletrônico) os dados de nenhum USUÁRIO do
            SITE, nem sequer os dados de tenha adquirido algum bem ofertado no SITE, sem o prévio consentimento de tal
            USUÁRIO.
          </p>
          <h3>Dos Cookies</h3>
          <p>
            O USUÁRIO e o visitante do SITE manifestam conhecer e aceitar que pode ser utilizado um sistema de
            monitoramento mediante utilização de cookies. Os cookies são pequenos arquivos que se instalam no disco
            rígido, com uma duração limitada de tempo que ajudam a personalizar os serviços. Também serão ofertadas
            algumas funcionalidades que só estarão disponíveis pelo emprego dos cookies. Os cookies são utilizados com o
            fim de conhecer os interesses, o comportamento e a demografia de quem visita ou é USUÁRIO do site, e dessa
            forma, compreender melhor suas necessidades e interesses e dar-lhes um melhor serviço ou prover-lhes
            informação relacionada.
          </p>
          <p>
            Também será usada a informação obtida por intermédio dos cookies para analisar as páginas navegadas pelo
            visitante ou USUÁRIO, as buscas realizadas, melhorar as iniciativas comerciais e promocionais, mostrar
            publicidade ou promoções, banners de interesse, notícias sobre o SITE, aperfeiçoar a oferta de conteúdos e
            bens, personalizar tais conteúdos, apresentação e serviços. Também poderá haver utilização de cookies para
            promover e fazer cumprir as regras e segurança do SITE.
          </p>
          <p>O SITE poderá adicionar cookies nos e-mails que envia para medir a efetividade das promoções.</p>
          <p>
            Utilizam-se adicionalmente os cookies para que o USUÁRIO não tenha que introduzir sua senha tão
            frequentemente durante uma seção de navegação, para contabilizar e corroborar os registros de atividade do
            USUÁRIO.
          </p>
          <p>
            Os cookies são utilizados sempre visando o benefício do USUÁRIO que o recebe, e não será usado com outros
            fins alheios à operação do SITE.
          </p>
          <p>
            A instalação, permanência e existência dos cookies no computador do USUÁRIO depende de sua exclusiva vontade
            e pode ser eliminado de seu computador quando o USUÁRIO assim o desejar.
          </p>
          <p>
            Adicionalmente, podem ser encontrados cookies ou outros sistemas similares instalados por terceiros em
            certas páginas do SITE, como por exemplo, ao navegar por uma página criada por um USUÁRIO.
          </p>
          <p>
            Fica esclarecido que esta política cobre a utilização de cookies pelo SITE e não a utilização de cookies por
            parte de anunciantes. O SITE não tem controle do uso de cookies por terceiros.
          </p>
          <p>
            Nossa política de cookies está de acordo com as mais recentes diretrizes da legislação existente sobre o
            tema.
          </p>
          <h3>Dos Web Beacons</h3>
          <p>
            Um Web beacon é uma imagem eletrônica, também chamada semgle-pixel (1 x 1) ou pixel transparente, que é
            colocada em código de uma página da web. Um Web beacon tem finalidades similares aos Cookies acima
            mencionados.
          </p>
          <p>
            Adicionalmente um Web beacon é utilizado para medir padrões de tráfego dos USUÁRIOS de uma página a outra
            com objetivo de maximizar o fluxo de tráfego através da web. O USUÁRIOS e o visitante do SITE manifesta
            conhecer e aceitar que o SITE poderá utilizar um sistema de monitoramento mediante a utilização de Web
            beacons.
          </p>
          <p>Da Ordem de autoridades competentes – Requerimentos Legais</p>
          <p>
            O SITE coopera com as autoridades competentes e terceiros para garantir o cumprimento das leis,
            especialmente, em matéria de proteção de direitos de propriedade industrial e intelectual, prevenção de
            fraudes, entre outros.
          </p>
          <p>
            O SITE poderá revelar os DADOS PESSOAIS de seus USUÁRIOS para atender a requerimentos de autoridades
            judiciais ou governamentais competentes, para fins de investigações conduzidas por estas, mesmo que não
            exista uma ordem judicial.
          </p>
          <p>
            O SITE pode comunicar qualquer DADO PESSOAL sobre seus USUÁRIOS com a finalidade de cumprir a lei aplicável
            e cooperar com as autoridades competentes para qualquer investigação de ilícito, infração de direitos de
            propriedade industrial ou intelectual, ou outra atividade que seja ilegal ou que possa expor o SITE ou seus
            USUÁRIOS, diretores, funcionários e prepostos a qualquer responsabilidade legal.
          </p>
          <p>
            O SITE pode, ainda, comunicar o nome completo do USUÁRIO, nome de USUÁRIO, domicílio, município, distrito,
            cep, país, número de telefone, endereço de e-mail, etc. aos participantes do Programa de Proteção de
            Propriedade Intelectual do SITE de forma que, possa ser investigada a fraude, infração de direitos de
            propriedade industrial ou intelectual, pirataria, ou qualquer outra atividade ilegal. Este direito será
            exercido pelo SITE a fim de cooperar com o cumprimento e execução da lei, independentemente de existir ou
            não uma ordem judicial ou administrativa para tanto.
          </p>
          <p>
            Além disso, o SITE se reserva o direito de comunicar os DADOS PESSOAIS de seus USUÁRIOS a outros USUÁRIOS,
            entidades ou terceiros, quando haja motivos suficientes para considerar que a atividade de um USUÁRIO seja
            suspeita de tentar ou de cometer um delito ou prejuízo a outras pessoas. Este direito será utilizado pelo
            SITE quando considere apropriado ou necessário para manter a integridade e a segurança da Comunidade e de
            seus USUÁRIOS, bem como para fazer cumprir os Termos e Condições Gerais (TERMO) e demais políticas do site e
            para cooperar com a execução e cumprimento da lei.
          </p>
          <h3>Da Segurança e Armazenamento da informação</h3>
          <p>
            O SITE é obrigado a observar todas as normas aplicáveis em matéria de medidas de segurança dos DADOS
            PESSOAIS e para tanto emprega os padrões mais avançados da indústria em matéria de proteção da
            confidencialidade das informações pessoais, a incluir, entre outras medidas, firewalls e Secure Socket
            Layers (“SSL”). O SITE considera os DADOS PESSOAIS de seus USUÁRIOS como um bem precioso que deve ser
            protegido de qualquer perda, acesso ou divulgação não autorizada.
          </p>
          <p>
            O SITE emprega, portanto, diversas técnicas de segurança para proteger tais DADOS PESSOAIS, não autorizando
            sua utilização por USUÁRIOS dentro ou fora da empresa.
          </p>
          <p>
            Ainda assim, é necessário considerar que a segurança perfeita não existe na internet. Portanto, o SITE não
            será responsável por interceptações ilegais ou violação de seus sistemas ou bases de dados por parte de
            pessoas não autorizadas, tampouco se responsabilizará pela indevida utilização da informação obtida por
            esses meios.
            <br />
            Todos os DADOS PESSOAIS dos USUÁRIOS são armazenados em um arquivo automatizado de DADOS PESSOAIS, locado
            nos EUA. O USUÁRIO, ao registrar-se no SITE, confirma que está informado da localização deste arquivo e
            autoriza esta transferência internacional de seus dados.
          </p>
          <h3>Das Mudanças nas preferências de e-mails</h3>
          <p>
            Sem prejuízo do SITE querer manter seus USUÁRIOS atualizados a todo momento sobre promoções, novidades,
            mudanças, etc. os USUÁRIOS podem selecionar os e-mails e informações promocionais que gostariam de receber
            do SITE. Se o USUÁRIO não quiser receber e-mails, pode alterar suas preferências de e-mails para que sejam
            consideradas nas futuras comunicações.
          </p>
          <h3>Da Informação na seção de perguntas e respostas ou fóruns</h3>
          <p>
            O SITE permite realizar perguntas e respostas nos anúncios e além disso mantém fóruns públicos (“fóruns”)
            que são fáceis de usar e navegar. Nestas seções os USUÁRIOS podem realizar comentários, dar opiniões,
            iniciar discussões e temas de seu interesse em um ambiente amigável, sempre sujeitos às regras aplicáveis
            nesta POLÍTICA.
          </p>
          <p>
            Os DADOS PESSOAIS inseridos na seção de perguntas e respostas ou nos fóruns podem ser lidos, coletados ou
            utilizados por qualquer pessoa. O SITE não será responsável pelo uso dessa informação publicada pelo USUÁRIO
            nestes campos do SITE.
          </p>
          <h3>Dos Direitos de cancelamento e retificação de dados pessoais</h3>
          <p>
            O USUÁRIO, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de acessar, cancelar e
            atualizar seus DADOS PESSOAIS. O USUÁRIO garante e responde pela veracidade, exatidão, vigência e
            autenticidade dos dados pessoais, e se compromete a mantê-los devidamente atualizados.
            <br />
            Uma vez cadastrado no SITE, o USUÁRIO poderá revisar e alterar a informação que houver fornecido durante o
            processo de cadastro, inclusive com relação:
          </p>
          <ul>
            <li>
              Ao nome de utilizador e endereço de e-mail, neste caso, sem prejuízo das mudanças que efetue, o SITE
              conservará os DADOS PESSOAIS originais por motivos de segurança e controle de fraudes;
            </li>
            <li>A informação do registro como: número de telefone, etc.</li>
            <li>A senha pessoal.</li>
          </ul>
          <p>
            Em determinados casos, serão mantidos nos arquivos do SITE os dados pessoais que nos tenham sido solicitados
            para remoção com o objetivo de utilização na solução de litígios ou reclamações, detecção de problemas ou
            incidentes e dar cumprimento ao disposto no TERMO. Em qualquer caso, os DADOS PESSOAIS do USUÁRIO não serão
            imediatamente retirados dos arquivos por razões legais e técnicas, a incluir os sistemas de suporte e
            segurança.
          </p>
          <p>
            O USUÁRIO deve atualizar seus DADOS PESSOAIS regularmente, com a alteração dos campos, a fim de que outros
            USUÁRIOS possam contatá-los quando realizarem uma negociação. Para fazer qualquer modificação na informação
            fornecida quando do cadastramento, o USUÁRIO deve acessar seu perfil pessoal no SITE.
          </p>
        </div>
      </Container>
    </Layout>
  )
}
